import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent } from '@/components/ui/card';

export const TableSkeleton = () => {
  return (
    <div className="space-y-6 p-4 md:p-6">
      <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-2">
          <Skeleton className="h-8 w-48 bg-muted" />

          <Skeleton className="h-4 w-64 bg-muted" />
        </div>
        <div className="flex w-full items-center gap-2 sm:w-auto">
          {/* Search Input */}
          <Skeleton className="h-10 w-full sm:w-64 bg-muted rounded-md" />

          <Skeleton className="h-10 w-32 bg-muted rounded-md" />
        </div>
      </div>

      <Card className="overflow-hidden border-border shadow-sm">
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            {/* Table Header Bar */}
            <div className="h-12 bg-muted/50 border-b border-border w-full flex items-center px-4 gap-4">
              <Skeleton className="h-4 w-24 bg-muted" />
              <Skeleton className="h-4 w-32 bg-muted" />
              <Skeleton className="h-4 w-20 bg-muted" />
              <Skeleton className="h-4 w-20 bg-muted ml-auto" />
            </div>

            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="h-16 border-b border-border px-4 flex items-center gap-4 bg-card"
              >
                {/* Checkbox/Icon */}
                <Skeleton className="h-5 w-5 rounded bg-muted" />

                {/* Project Name & Meta */}
                <div className="flex flex-col gap-2 flex-1">
                  <Skeleton className="h-4 w-48 bg-muted" />
                  <Skeleton className="h-3 w-32 bg-muted/60" />
                </div>

                {/* Date Column */}
                <Skeleton className="h-4 w-24 bg-muted hidden sm:block" />

                {/* Status Badge */}
                <Skeleton className="h-6 w-20 rounded-full bg-muted hidden md:block" />

                {/* Action Icon */}
                <Skeleton className="h-8 w-8 rounded bg-muted ml-auto" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-48 bg-muted" />
        <div className="flex gap-2">
          <Skeleton className="h-9 w-20 bg-muted rounded-md" />
          <Skeleton className="h-9 w-20 bg-muted rounded-md" />
        </div>
      </div>
    </div>
  );
};
